<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<section class="part_search_bar">
  <div class="row no-mar-lr">
    <!-- <div class="col-md-6 search_input">
      <input *ngIf="config.filtering" placeholder="{{'NewPart_Search_Placeholder' | translate}}" [ngTableFiltering]="config.filtering"
        class="form-control" />
      <span class="input-group-btn">
        <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
          {{'Search' | translate}}
        </button>
      </span>
    </div> -->

    <div class="col-md-6 search_input input-group custom-search-form" >
      <input type="text" class="form-control"  class="form-control" placeholder="{{'SEARCHBY' | translate}}" [(ngModel)]="srchValue">
      <span class="input-group-btn">
        <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
          {{'Search' | translate}}
        </button>
      </span>
    </div>

  </div>
</section>
<div class="dta_title pad-lr-15 mar-top-20 col-md-3">{{ 'NEWPARTS' | translate}}</div>
<div class="row no-mar-lr">
  <div class="col-md-10 mar-btm-30">
    <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination>
     <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns">
    </ng-table> -->
    <!-- <pre *ngIf="config.paging" class="card card-block card-header">Page: {{page}} / {{numPages}}</pre> -->

    <!-- <ngx-datatable tableClass="table table-striped table-bordered table-hover" [data]="data" [options]="options"
    [columns]="columns">
  </ngx-datatable> -->


  <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination>
  
  <div class="example-container mat-elevation-z8">
  
    <mat-table [dataSource]="dataSource" >
  
     
      <ng-container matColumnDef="partNumber">
        <mat-header-cell *matHeaderCellDef > Part Number </mat-header-cell>
        <mat-cell *matCellDef="let row">  <a class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a> </mat-cell>
        
      </ng-container>
  
     
      <ng-container matColumnDef="partName">
        <mat-header-cell *matHeaderCellDef > Part Name </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="deliveryPoint">
        <mat-header-cell *matHeaderCellDef > Delivery Point </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.deliveryPoint}} </mat-cell>
      </ng-container>
  
      
      <ng-container matColumnDef="nextProcess">
        <mat-header-cell *matHeaderCellDef > Next Process </mat-header-cell>
        <mat-cell *matCellDef="let row" [style.color]="row.lineNumber"> {{row.lineNumber}} </mat-cell>
      </ng-container>


      <ng-container matColumnDef="assignedDate">
        <mat-header-cell *matHeaderCellDef > Assigned Date </mat-header-cell>
        <mat-cell *matCellDef="let row" [style.color]="row.assignedDate" > {{row.assignedDate}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <mat-header-cell *matHeaderCellDef > Due Date </mat-header-cell>
        <mat-cell *matCellDef="let row" [style.color]="row.dueDate"> {{row.dueDate}} </mat-cell>
      </ng-container>
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>
  
  
  </div>
  




 </div>
</div>


